/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import { useRef, useState, useEffect, useCallback } from 'react';
import { useWindowSize } from 'layout/homepage/useWindowSize';

const TabsBar = (props) => {
    let tabNavRef = useRef(null);
    const { tabs, selectTab, selected } = props;
    const { windowSize } = useWindowSize();
    const [tabsClass, setTabsClass] = useState('tab-nav');

    const onClickTab = (event, id) => {
        selectTab(event, id);
    };

    const getClassNames = useCallback(() => {
        let cn = 'tab-nav';
        if (tabNavRef.current && tabNavRef.current.clientHeight > 54) {
            cn = cn + ' wrap';
        }

        if (tabs.length > 3) {
            cn = cn + ' long';
        }
        if (tabs.length <= 3 && windowSize.width > 580) {
            cn = cn.replace(' wrap', '');
        }
        console.log(cn);
        setTabsClass(cn);
    }, [tabs, windowSize]);

    useEffect(() => {
        // onload
        getClassNames();

        const handleResize = () => {
            getClassNames();
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [getClassNames, tabs]);

    return (
        <div className='tab-nav-wrapper website-tab-bar-wrapper'>
            <ul className={tabsClass} role='tablist'>
                {tabs.map((tab, index) => {
                    const { id, text } = tab || {};
                    const visible = selected === id;
                    return (
                        <li
                            key={id}
                            data-tab-index={index}
                            role='tab'
                            tabIndex={0}
                            aria-selected={selected}
                            aria-controls={id}
                            id={id}
                            onClick={(event) => onClickTab(event, id)}
                            onKeyDown={ (e) => {if (e.key === 'Enter') { onClickTab(e, id) } }}
                            className={visible ? 'active' : ''}
                        >
                            <span>{text}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

TabsBar.displayName = 'TabsBar';
export { TabsBar };
